/**
 * Palantir PMS - Software para la gestión de la industria hotelera
 * Palantir PMS - Software for hotel industry management
 * Autor / Author: Alberto Castro Ull
 * Fecha de creación / Created on: 31/07/2025
 * Todos los derechos reservados / All rights reserved.
 * Este software es propiedad de Alberto Castro Ull.
 * This software is the property of Alberto Castro Ull.
 * Su uso está restringido a clientes con licencia emitida por Markulia Group, S.L.
 * Use is restricted to clients licensed by Markulia Group, S.L.
 */

import axios from "../api/axiosInstance";

    export const reloadDatesFromDB = async (reservationId, setDbDatesMap) => {
    if (!reservationId) return;

    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/reservation-drafts/${reservationId}`);
      const check_in_date = res.data?.check_in_date || null;
      const check_out_date = res.data?.check_out_date || null;

      setDbDatesMap(prev => ({
        ...prev,
        [reservationId]: {
          check_in_date,
          check_out_date
        }
      }));

      console.log(`✅ Fechas cargadas desde DB para reserva ${reservationId}:`, { check_in_date, check_out_date });
    } catch (err) {
      console.error("❌ Error al recargar fechas desde la base de datos:", err);
      setDbDatesMap(prev => ({
        ...prev,
        [reservationId]: {
          check_in_date: null,
          check_out_date: null
        }
      }));
    }
  };

  export const reloadAdultsFromDB = async (reservationId, setAdultsMap, selectedReservationId, reservationIdRef) => {
    if (!reservationId) return;

    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/reservation-drafts/${reservationId}`);
      const adults = res.data?.adults || 0;

      setAdultsMap(prev => ({
        ...prev,
        [reservationId]: adults
      }));

      console.log(`✅ Adults recargado para ${reservationId}:`, adults);
       console.log(
      `✅ Adults recargado para ${reservationId}:`,
      adults,
      "| selectedReservationId:",
      "| reservationIdRef.current:"
    );
    } catch (err) {
      console.error("❌ Error recargando adults:", err);
      setAdultsMap(prev => ({
        ...prev,
        [reservationId]: 0
      }));
    }
  };

  export const reloadChildrenFromDB = async (reservationId, setChildrenMap) => {
    if (!reservationId) return;

    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/reservation-drafts/${reservationId}`);
      const children = res.data?.children || 0;

      setChildrenMap(prev => ({
        ...prev,
        [reservationId]: children
      }));

      console.log(`✅ Children recargado para ${reservationId}:`, children);
    } catch (err) {
      console.error("❌ Error recargando children:", err);
      setChildrenMap(prev => ({
        ...prev,
        [reservationId]: 0
      }));
    }
  };

  export const reloadRoomCategoryIdFromDB = async (reservationId, setRoomCategoryMap) => {
    if (!reservationId) return;

    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/reservation-drafts/${reservationId}`);
      const categoryId = res.data?.room_category_id;

      if (!categoryId) {
        setRoomCategoryMap(prev => ({
          ...prev,
          [reservationId]: null
        }));
        return;
      }

      const catRes = await axios.get(`${process.env.REACT_APP_API_URL}/api/room_categories/${categoryId}`);
      const categoryName = catRes.data?.name || `ID ${categoryId}`;

      setRoomCategoryMap(prev => ({
        ...prev,
        [reservationId]: categoryName
      }));

      console.log(`✅ Nombre de categoría cargado: ${categoryName}`);
    } catch (err) {
      console.error("❌ Error recargando nombre de categoría:", err);
      setRoomCategoryMap(prev => ({
        ...prev,
        [reservationId]: null
      }));
    }
  };

  export const reloadRoomCategoryDetailsFromDB = async (reservationId, setRoomCategoryDetailsMap) => {
  if (!reservationId) return;

  try {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/reservation-drafts/${reservationId}`);
    const categoryId = res.data?.room_category_id;

    if (!categoryId) {
      setRoomCategoryDetailsMap(prev => ({
        ...prev,
        [reservationId]: null
      }));
      return;
    }

    const catRes = await axios.get(`${process.env.REACT_APP_API_URL}/api/room_categories/${categoryId}`);
    const cat = catRes.data;

    setRoomCategoryDetailsMap(prev => ({
      ...prev,
      [reservationId]: {
        id: cat.id,
        name: cat.name
      }
    }));

    console.log(`✅ Room category cargada: ${cat.name}`);
  } catch (err) {
    console.error("❌ Error recargando categoría:", err);
    setRoomCategoryDetailsMap(prev => ({
      ...prev,
      [reservationId]: null
    }));
  }
};


  export const reloadRoomIdFromDB = async (reservationId, setRoomIdMap) => {
  if (!reservationId) return;

  try {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/reservation-drafts/${reservationId}`);
    const roomId = res.data?.room_id;

    if (roomId === null || roomId === undefined) {
      setRoomIdMap(prev => ({
        ...prev,
        [reservationId]: null
      }));
      return;
    }

    // ⚠️ Asegúrate de que esta ruta existe: /api/rooms/:id
    const roomRes = await axios.get(`${process.env.REACT_APP_API_URL}/api/rooms/${roomId}`);
    const room = roomRes.data;

    const readable = `${room.room_number} ${room.name || room.description || ""}`.trim();

    setRoomIdMap(prev => ({
      ...prev,
      [reservationId]: readable
    }));

    console.log(`✅ Nombre de habitación cargado: ${readable}`);
  } catch (err) {
    console.error("❌ Error recargando habitación:", err);
    setRoomIdMap(prev => ({
      ...prev,
      [reservationId]: null
    }));
  }
  };

  export const reloadRoomRateIdFromDB = async (reservationId, setRoomRateDetailsMap) => {
    if (!reservationId) return;

    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/reservation-drafts/${reservationId}`);
      const rateId = res.data?.rate_id;

      if (!rateId) {
        setRoomRateDetailsMap(prev => ({
          ...prev,
          [reservationId]: null
        }));
        return;
      }

      const rateRes = await axios.get(`${process.env.REACT_APP_API_URL}/api/roomRates/${rateId}`);
      const rate = rateRes.data;

      setRoomRateDetailsMap(prev => ({
        ...prev,
        [reservationId]: {
          id: rate.id,
          name: rate.name,
          client_name: rate.client?.name || null
        }
      }));

      console.log(`✅ Room Rate cargado: ${rate.name} (${rate.client?.name || "no client"})`);
    } catch (err) {
      console.error("❌ Error recargando room_rate:", err);
      setRoomRateDetailsMap(prev => ({
        ...prev,
        [reservationId]: null
      }));
    }
  };

  export const reloadGroupRateIdFromDB = async (reservationId, setGroupRateIdMap) => {
  if (!reservationId) return;

  try {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/reservation-drafts/${reservationId}`);
    const groupRateId = res.data?.group_rate_id;

    setGroupRateIdMap(prev => ({
      ...prev,
      [reservationId]: groupRateId ?? null
    }));

    console.log(`✅ Group Rate ID recargado para ${reservationId}:`, groupRateId);
  } catch (err) {
    console.error("❌ Error recargando group_rate_id:", err);
    setGroupRateIdMap(prev => ({
      ...prev,
      [reservationId]: null
    }));
  }
};
